import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { closeModal } from '../../../../redux/modals/action';
import { setDepositSchedule } from '../../../../api/Agreement/setDepositSchedule.api';
import { setDepositCheck } from '../../../../api/Agreement/setDepositCheck.api';
import Modal from '../../../layout/modal/Modal';
import dayjs from 'dayjs';
import { numberWithCommas } from '../../../../utils/numberWithCommas';
import { stringifyNumber } from '../../../../utils/stringifyNumber';
import { capitalizeFirstLetter } from '../../../../utils/capitalizeFirstLetter';
import styles from './ViewDepositScheduleModal.module.scss';
import clsx from 'clsx';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CloseIcon from '@mui/icons-material/Close';
import UploadIcon from '@mui/icons-material/Upload';
import {
	Table,
	TableContainer,
	TableHead,
	TableRow,
	TableCell,
	TableBody,
	TextField,
	MenuItem,
	Tooltip,
	Dialog,
	DialogTitle,
	DialogContent,
	IconButton,
} from '@material-ui/core';

const ViewDepositScheduleModal = ({
	// parent props
	showModal,
	closeDepositModal,
	// redux
	closeModal,
	depositSchedule,
	purchaserById,
}) => {
	const [open, setOpen] = useState(false);
	const [deposit, setDeposit] = useState();
	const [total, setTotal] = useState();
	const [form, setForm] = useState();
	const [src, setSrc] = useState();

	useEffect(() => {
		setDeposit(depositSchedule);
		setForm(depositSchedule);
		let total = 0;
		depositSchedule &&
			depositSchedule?.map((deposit) => {
				total = total + Number(deposit?.installment);
			});

		setTotal(numberWithCommas(Number(total).toFixed(2)) || 0);
	}, [depositSchedule]);

	const onChange = (e) => {
		let leadId = purchaserById?.leadId;
		let name = e.target.name;
		let value = e.target.value;
		setForm({
			...form,
			[name]: {
				...form[name],
				status: value,
			},
		});
		leadId && setDepositSchedule(leadId, value, name);
	};

	const onChangeImgFile = (e, index) => {
		let leadId = purchaserById?.leadId;
		if (e.target.files.length) {
			const file = e.target.files[0];
			const fileType = file['type'];
			const validImageTypes = ['image/gif', 'image/jpeg', 'image/png'];
			console.log('depositSchedlue onChangeImgFile', index);
			if (validImageTypes.includes(fileType) && leadId) {
				index !== undefined && setDepositCheck(leadId, index, file);
			}
		}
	};

	const handlePreviewOpen = (src) => {
		setSrc(src);
		setOpen(true);
	};

	const handleCloseModal = () => {
		if (purchaserById?.leadId) {
			closeDepositModal(purchaserById?.leadId);
		} else {
			closeModal('depositSchedule');
		}
	};

	return (
		<div className={styles.depositScheduleWrapper}>
			<Modal
				show={showModal}
				close={() => handleCloseModal()}
				title='Deposit Schedule'
				wrapperWidth={'95%'}
				wrapperMax={800}
			>
				{depositSchedule ? (
					<>
						<TableContainer>
							<Table className={styles.table}>
								<TableHead>
									<TableRow>
										<TableCell />
										<TableCell>Date</TableCell>
										<TableCell>Amount</TableCell>
										<TableCell>Status</TableCell>
										<TableCell />
									</TableRow>
								</TableHead>
								<TableBody>
									{deposit?.map((schedule, index) => {
										var date;
										if (schedule.date === 'At Occupancy') {
											date = schedule.date;
										} else {
											date = dayjs(schedule.date).format(
												'DD MMM, YYYY'
											);
										}
										return (
											<TableRow key={index}>
												<TableCell>
													<CheckCircleIcon
														className={clsx(
															styles.chkIcon,
															schedule?.status ===
																'nsf'
																? styles.error
																: schedule?.status ===
																  'cleared'
																? styles.success
																: null
														)}
													/>
													<span>
														{capitalizeFirstLetter(
															stringifyNumber(
																index + 1
															)
														)}
														&nbsp;Deposit
													</span>
												</TableCell>
												<TableCell>{date}</TableCell>
												<TableCell>
													${' '}
													{numberWithCommas(
														schedule.installment.toFixed(
															2
														)
													)}
												</TableCell>
												<TableCell>
													<TextField
														className={
															styles.inputSelect
														}
														value={
															form[index]
																.status ?? ''
														}
														name={index.toString()}
														select
														onChange={(e) =>
															onChange(e)
														}
														variant='outlined'
														size='small'
													>
														<MenuItem value=''>
															-
														</MenuItem>
														<MenuItem value='nsf'>
															NSF
														</MenuItem>
														<MenuItem value='cleared'>
															Cleared
														</MenuItem>
													</TextField>
												</TableCell>
												<TableCell>
													{schedule?.img ? (
														<>
															<Tooltip
																title='View'
																arrow
															>
																<VisibilityIcon
																	className={
																		styles.imgIcon
																	}
																	onClick={() =>
																		handlePreviewOpen(
																			schedule.img
																		)
																	}
																/>
															</Tooltip>
														</>
													) : (
														<>
															<Tooltip
																title={'Upload'}
																arrow
															>
																<div>
																	<input
																		type='file'
																		accept='image/*'
																		onChange={(
																			e
																		) =>
																			onChangeImgFile(
																				e,
																				index
																			)
																		}
																		// id='upload-button'
																		id={`upload-button${index}`}
																		hidden
																		style={{
																			display:
																				'none',
																		}}
																	/>
																	<label
																		// htmlFor='upload-button'
																		htmlFor={`upload-button${index}`}
																	>
																		<div
																			className={
																				styles.imgIcon
																			}
																		>
																			<UploadIcon />
																		</div>
																	</label>
																</div>
															</Tooltip>
														</>
													)}
												</TableCell>
											</TableRow>
										);
									})}
									<TableRow className={styles.trTotal}>
										<TableCell>Total Deposit</TableCell>
										<TableCell />
										<TableCell>$ {total}</TableCell>
										<TableCell />
										<TableCell />
									</TableRow>
								</TableBody>
							</Table>
						</TableContainer>
					</>
				) : (
					<div className={styles.emptyHandler}>
						No information displayed yet.
					</div>
				)}
			</Modal>
			<Dialog
				open={open}
				onClose={() => setOpen(false)}
				fullWidth={true}
				maxWidth='md'
			>
				<DialogTitle
					onClose={() => setOpen(false)}
					className={styles.previewDialog}
				>
					Image Preview
					<IconButton
						aria-label='close check image'
						onClick={() => setOpen(false)}
						style={{ position: 'absolute', top: 5, right: 5 }}
					>
						<CloseIcon />
					</IconButton>
				</DialogTitle>
				<DialogContent className={styles.previewContent}>
					<div>
						<center>
							<img
								className={styles.previewImg}
								src={src}
								width='100%'
								height={'100%'}
							/>
						</center>
					</div>
				</DialogContent>
			</Dialog>
		</div>
	);
};
const mapStateToProps = (state) => ({
	depositSchedule: state.agreement.agreementById.depositSchedule,
	purchaserById: state.purchasers.purchaserById,
});
export default connect(mapStateToProps, { closeModal })(
	ViewDepositScheduleModal
);
